module.exports = __webpack_public_path__ + "static/media/profilePic.b68fe692.png";